import { isEmpty } from 'lodash'
import React from 'react'
import { Button, Card, CardBody } from 'reactstrap'


const NoAccessComponent = () => {
    return (
        <Card>
            <CardBody>
                <div className='d-flex flex-column py-5 align-items-center'>
                    <i className='fa fa-lock fa-3x text-warning mb-3' />
                    <h5>Industry, Ratings, Shareholding Patter and more sections locked.</h5>
                    <p className='text-muted'>Please show interest to access additional entity informtion</p>
                </div>
            </CardBody>
        </Card>
    )
}

const AccessComponent = ({ handleMoreInfo }) => {
    return (
        <Button color='btn btn-outline-success mx-auto d-block mb-5' role='button' onClick={handleMoreInfo}>View more information on the Entity <i className='fa fa-arrow-right' /></Button>
    )
}

const ShowMoreComponent = ({ handleMoreInfo, entityData }) => {
    const userData = localStorage.getItem('user')

    if (isEmpty(userData)) {
        return null
    }

    const isIntrested = entityData?.isIntested


    return (
        isIntrested == '1' ? <AccessComponent handleMoreInfo={handleMoreInfo} /> : <NoAccessComponent />
    )
}

export default ShowMoreComponent